/**
 * Labstep
 *
 * @desc Manager for PermissionRole
 */

import { PermissionRoleActionCreate } from 'labstep-web/components/PermissionRole/Action/Create';
import { PermissionRoleTableContainer as PermissionRoleTable } from 'labstep-web/components/PermissionRole/Table';
import type React from 'react';
import styles from './styles.module.scss';
import type { IPermissionRoleManagerProps } from './types';

export const PermissionRoleManager: React.FC<
  IPermissionRoleManagerProps
> = ({ organization }) => (
  <div className={styles.container}>
    <PermissionRoleActionCreate organization={organization} />
    <PermissionRoleTable
      organization={organization}
      permissionRoles={organization.permission_roles.filter(
        (e) => !e.deleted_at,
      )}
    />
  </div>
);
